const getEUCountryList = ():string[] => {
    const country = [
        "AT", //Austria
        "AL", //Albania
        "AD", //Andorra
        "AM", //Armenia
        "AZ", //Azerbaijan
        "BE", //Belgium
        "BA", //Bosnia and Herzegovina
        "BY", //Belarus
        "BG", //Bulgaria
        "HR", //Croatia
        "CY", //Cyprus
        "CZ", //Czechia
        "DK", //Denmark
        "EE", //Estonia
        "FO", //Faroe Islands
        "FI", //Finland
        "FR", //France
        "DE", //Germany
        "GI", //Gibraltar
        "GR", //Greece
        "GE", //Georgia
        "HU", //Hungary
        "IE", //Ireland
        "IS", //Iceland
        "IT", //Italy
        "LV", //Latvia
        "LT", //Lithuania
        "LI", //Liechtenstein
        "KZ", //Kazakhstan
        "XK", //Kosovo
        "LU", //Luxembourg
        "MT", //Malta
        "MD", //Moldova
        "MC", //Monaco
        "ME", //Montenegro
        "NL", //Netherlands
        "MK", //North Macedonia
        "NO", //Norway
        "PL", //Poland
        "PT", //Portugal
        "RO", //Romania
        "RU", //Russia
        "SM", //San Marino
        "SK", //Slovakia
        "RS", //Serbia
        "SI", //Slovenia
        "ES", //Spain
        "SE", //Sweden
        "CH", //Switzerland
        "TR", //Turkey
        "UA", //Ukraine
        "VA", //Vatican City
    ];

    return country;
}

export default getEUCountryList